import { MenuItem } from "primeng/api";
import { AuthUserModel, CargoFeaturesModel, ClientInfoModel } from "../model";

export abstract class AbstractMenuModule {

    protected copyMenuItems(items: MenuItem[]): MenuItem[] {
        return JSON.parse(JSON.stringify(items));
    }

    abstract checkUserRole(roleName?: string): boolean;
    abstract buildMenu(user?: ClientInfoModel, auth?: AuthUserModel, features?: CargoFeaturesModel): MenuItem[];
}